<ng-container *ngIf="productURL$ | async">
  <ng-container *ngIf="pli">

    <a *ngIf="!pli.isFreeGift" data-inline="true" [title]="productName$ | async" [routerLink]="productURL$ | async">
      <fa-icon [icon]="icon"></fa-icon>
    </a>
  </ng-container>
</ng-container>